var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlidersOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 15C20.0856 15 21.4249 16.0543 21.8551 17.5002L24 17.5C24.5523 17.5 25 17.9477 25 18.5C25 19.0523 24.5523 19.5 24 19.5L21.8548 19.5008C21.4243 20.9462 20.0852 22 18.5 22C16.9148 22 15.5757 20.9462 15.1452 19.5008L4 19.5C3.44772 19.5 3 19.0523 3 18.5C3 17.9477 3.44772 17.5 4 17.5L15.1449 17.5002C15.5751 16.0543 16.9144 15 18.5 15ZM18.5 16.75C17.5335 16.75 16.75 17.5335 16.75 18.5C16.75 19.4665 17.5335 20.25 18.5 20.25C19.4665 20.25 20.25 19.4665 20.25 18.5C20.25 17.5335 19.4665 16.75 18.5 16.75ZM10.5 6C12.0856 6 13.4249 7.05433 13.8551 8.50016L24 8.5C24.5523 8.5 25 8.94772 25 9.5C25 10.0523 24.5523 10.5 24 10.5L13.8548 10.5008C13.4243 11.9462 12.0852 13 10.5 13C8.9148 13 7.57573 11.9462 7.14519 10.5008L4 10.5C3.44772 10.5 3 10.0523 3 9.5C3 8.94772 3.44772 8.5 4 8.5L7.14489 8.50016C7.57511 7.05433 8.91443 6 10.5 6ZM10.5 7.75C9.5335 7.75 8.75 8.5335 8.75 9.5C8.75 10.4665 9.5335 11.25 10.5 11.25C11.4665 11.25 12.25 10.4665 12.25 9.5C12.25 8.5335 11.4665 7.75 10.5 7.75Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlidersOutline);
export default __webpack_public_path__ + "static/media/sliders_outline.726fd22603972ab7f4e632c32241aad5.svg";
export { ForwardRef as ReactComponent };